import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Button from "../../components/Button/Button";

const RealEstateHero = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section
      className="relative min-h-[90vh] bg-white overflow-hidden pt-8"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Text Section */}
        <div className="flex-1 text-center lg:text-left">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6"
          >
            Improving tenant and client relationships
            <br /> in Real Estate.
          </motion.h1>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-gray-600 text-lg mb-8 max-w-xl mx-auto lg:mx-0"
          >
            Zola’s Customer Experience Platform gathers feedback from tenants,
            buyers, and renters. With multi-channel tools, every interaction can
            be positive.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex justify-center lg:justify-start gap-4"
          >
            <Button variant="primary">Get started</Button>
            <Button variant="secondary" calendly>
              Book a demo
            </Button>
          </motion.div>
        </div>

        {/* Image Section */}
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={inView ? { scale: 1, opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex-1 relative flex justify-center items-center"
        >
          <img
            src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f63210b2811c51f96e5d23_smiley-embraced-couple-conversing-with-female-realtor.jpg"
            alt="Happy Couple"
            className="relative z-10 w-[560px] h-[80vh] rounded-tl-[150px] object-cover"
          />

          {/* Background pattern */}
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={inView ? { x: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="absolute -top-36 -right-36 h-8 object-cover pointer-events-none z-20"
          >
            <img
              src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f62a1d1fca97c1aefd4d5d_18df144858b555cf937b65bdd5fc1726_Line%20Pattern%20Header%201.1.svg"
              alt="Pattern"
              className="w-full"
            />
          </motion.div>

          {/* Reviews Card (Top Left Overlay) */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="absolute bottom-48 -left-24 w-[220px] md:w-[250px] bg-white rounded-xl shadow-xl p-4 z-20"
          >
            <img
              src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f62bfe12e323f8f8f51d1f_Frame%202085665073.png"
              alt="Review Platforms"
              className="w-full"
            />
          </motion.div>

          {/* Total Reviews (Bottom Right Overlay) */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="absolute bottom-12 -left-16 w-[250px] bg-white rounded-xl shadow-xl p-4 z-20"
          >
            <img
              src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f62c75b5a967f3eb409e6c_Group%201000005181%20(4).png"
              alt="Total Reviews"
              className="w-full"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default RealEstateHero;
